import {
  SET_ACCESS_TOKEN,
  SET_LAST_TOKEN,
  SET_TIME_OUT_NOTICE,
  SET_REDIRECT_AFTER_AUTH,
  SET_FIREBASE_MESSAGING_TOKEN,
  SET_AUTH_REQUEST_DATA,
  SET_LOGIN_STEP,
  SET_LOGIN_REQUESTID,
  SET_RECOVERY_STEP,
  SET_RECOVERY_REQUESTID,
} from './types'

function setAccessToken(accessToken) {
  return {
    type: SET_ACCESS_TOKEN,
    payload: {
      accessToken,
    },
  }
}

function setLastAccessed(lastAccessed) {
  return {
    type: SET_LAST_TOKEN,
    payload: {
      lastAccessed,
    },
  }
}

function setTimeOutNotice(showTimeOutNotice) {
  return {
    type: SET_TIME_OUT_NOTICE,
    payload: {
      showTimeOutNotice,
    },
  }
}

function setRedirectAfterAuth(redirectAfterAuth) {
  return {
    type: SET_REDIRECT_AFTER_AUTH,
    payload: {
      redirectAfterAuth,
    },
  }
}

function setFirebaseMessagingToken(firebaseMessagingToken) {
  return {
    type: SET_FIREBASE_MESSAGING_TOKEN,
    payload: {
      firebaseMessagingToken,
    },
  }
}

function setAuthRequestData(authRequestData) {
  return {
    type: SET_AUTH_REQUEST_DATA,
    payload: {
      authRequestData,
    },
  }
}

function setLoginStep(loginStep) {
  return {
    type: SET_LOGIN_STEP,
    payload: {
      loginStep,
    },
  }
}

function setLoginRequestId(loginRequestId) {
  return {
    type: SET_LOGIN_REQUESTID,
    payload: {
      loginRequestId,
    },
  }
}

function setRecoveryStep(recoveryStep) {
  return {
    type: SET_RECOVERY_STEP,
    payload: {
      recoveryStep,
    },
  }
}

function setRecoveryRequestId(recoveryRequestId) {
  return {
    type: SET_RECOVERY_REQUESTID,
    payload: {
      recoveryRequestId,
    },
  }
}

export {
  setAccessToken,
  setLastAccessed,
  setTimeOutNotice,
  setRedirectAfterAuth,
  setFirebaseMessagingToken,
  setAuthRequestData,
  setLoginStep,
  setLoginRequestId,
  setRecoveryStep,
  setRecoveryRequestId,
}
